export default class CustomizeTheme {
  constructor() {
    this.form = document.querySelector('form#theme_update');
    if (this.form) {
      this.siteNameInput = this.form.querySelector('#' + this.form.id + '_site_name');
      this.siteNameInput.addEventListener('keyup', this.onSiteNameInputChange.bind(this));

      this.themeImages = document.querySelectorAll('.theme-image');
      if (this.themeImages.length) {
        for (const image of this.themeImages) {
          this.setImgSizeBaseOnOrientation(image);
        }
      }

      this.themeImagesLg = document.querySelectorAll('.theme-image-lg');
      if (this.themeImagesLg.length) {
        for (const image of this.themeImagesLg) {
          this.setImgSizeBaseOnOrientation(image);
        }
      }

      this.siteLogoInput = document.getElementById('theme_update_site_logo');
      if (this.siteLogoInput) {
        this.siteLogoInput.addEventListener('change', this.onChangeSiteLogo.bind(this));
      }

      this.siteHeroInput = document.getElementById('theme_update_hero_image');
      if (this.siteHeroInput) {
        this.siteHeroInput.addEventListener('change', this.onChangeSiteHero.bind(this));
      }

      // Move launch button after the preview in smaller screens.
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      if (viewportWidth < 992) {
        const btn = document.getElementById('theme_btn');
        const preview = document.getElementById('themePrev');
        btn.remove();
        preview.after(btn);
      }

      [
        '#theme_update_columns_primary_color',
        '#theme_update_columns_secondary_color',
        '#theme_update_columns_tertiary_color'
      ].forEach( (picker) => {
        const $colorPicker = $(picker);
        this.updatePreviewColors($colorPicker[0], $colorPicker[0].value);

        $colorPicker.on('change', this.onChangeColorPicker.bind(this));
      });
    }
  }

  onSiteNameInputChange( event ) {
    const siteName = document.querySelector('#preview_site_name');
    siteName.innerText = event.target.value;
  }

  onChangeColorPicker( event ) {
    const picker = event.target;
    this.updatePreviewColors(picker, event.color);
  }

  updatePreviewColors(picker, color) {
    $('.' + picker.dataset.name).css('background-color', color);
    $('.' + picker.dataset.name + '_triangle').css('border-color', `transparent transparent ${ color } transparent`);
  }

  setImgSizeBaseOnOrientation = image => {
    const width = image.naturalWidth || image.width;
    const height = image.naturalHeight || image.height;
    const aspectRatio = width/height;
    const parent = image.parentElement;
    parent.className = 'text-start';
    if (aspectRatio > 1) {
      // Image is landscape
      parent.classList.add('w-xs-45p');
    } if (aspectRatio > 2) {
      // Image is large
      parent.classList.add('w-xs-220p');
      parent.classList.remove('text-start');
    } else {
      // Image is square
      parent.classList.add('w-xs-40p');
    }
  }

  onChangeSiteLogo() {
    const reader = new FileReader();
    const logoName = $('#custom_name');
    const file = this.siteLogoInput.files[0];
    file && logoName.html(file.name);

    reader.addEventListener('load', (e) => {
      for (const image of this.themeImages) {
        image.onload = () => {
          this.setImgSizeBaseOnOrientation(image);
        }
        image.setAttribute('src', e.target.result);
      }
    });
    if (file) {
      reader.readAsDataURL(file);
    }
  }

  onChangeSiteHero() {
    const reader = new FileReader();
    const heroName = $('#custom_hero_name');
    const file = this.siteHeroInput.files[0];
    file && heroName.html(file.name);

    reader.addEventListener('load', (e) => {
      for (const image of this.themeImagesLg) {
        image.onload = () => {
          this.setImgSizeBaseOnOrientation(image);
        }
        image.setAttribute('src', e.target.result);
      }
    });
    if (file) {
      reader.readAsDataURL(file);
    }
  }
}
